<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Manage Apps</h4>
</div>
<div class="modal-body">
  <div class="apps-modal-container">
    <form [formGroup]="addAppForm">
      <div *ngIf="app.company !== null && data.user_type == 1">
        <!-- Edit App -->
        <h4>App Information</h4>
        <p>Edit this app information.</p>

        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="AppNameInput01">App name</label>
              <input
                id="AppNameInput01"
                type="text"
                autofocus
                formControlName="name"
                class="form-control"
                placeholder="QuickBooks"
              />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="AppCategory01">App category</label>
              <select
                id="AppCategory01"
                class="form-control"
                (change)="categoryChange($event.target.value)"
                formControlName="category"
              >
                <option value="" selected disabled>Choose a category</option>
                <option value="Accounting">Accounting</option>
                <option value="A/P and A/R">A/P and A/R</option>
                <option value="Document Retrieval">Document Retrieval</option>
                <option value="Receipt Capture">Receipt Capture</option>
                <option value="Payroll">Payroll</option>
                <option value="Expense Management">Expense Management</option>
                <option value="Time Tracking">Time Tracking</option>
                <option value="Mileage Tracking">Mileage Tracking</option>
                <option value="Banking">Banking</option>
                <option value="Other Category">Other Category</option>
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="AppLogo01">App logo / icon</label>
              <input
                id="AppLogo01"
                type="file"
                accept=".pdf,.doc,.docx,.pptx,.ppt,.xls,.xlsx,.csv,.txt,.rtf,.html,.zip,.mp3,.wma,.mpg,.flv,.avi,.jpg,.jpeg,.png,.gif,.ofx,.qbo,.iif,.qbx,.qbm,.qbb,.qbw"
                #appInput
                class="form-control"
              />
            </div>
          </div>
          <div class="col-sm-12" *ngIf="show_other_category">
            <div class="form-group">
              <label for="AppCategory02">Category Name</label>
              <input
                id="AppCategory02"
                type="text"
                class="form-control"
                formControlName="category_other"
                placeholder="Category Name"
              />
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label for="AppURL01">App login URL</label>
              <input
                id="AppURL01"
                type="text"
                formControlName="url"
                class="form-control"
                placeholder="https://domain.com/login"
              />
            </div>
          </div>
        </div>

        <button class="btn btn-danger" (click)="openConfirmation(template)">
          <i class="feather trash-2"></i> Remove App
        </button>

        <!-- End Edit App -->
      </div>
    </form>

    <!-- <a href="javascript:;" class="color-red-hover"><i class="feather trash-2"></i> Delete App</a> -->
  </div>
  <!-- Add app component here -->
</div>
<div class="modal-footer">
  <!-- <button class="btn btn-primary pull-left" *ngIf="showAddApp == true"><i class="feather plus"></i> Add App</button> -->
  <button
    type="button"
    class="btn btn-default pull-left"
    (click)="bsModalRef.hide()"
  >
    Cancel
  </button>
  <button type="button" class="btn btn-primary pull-right" (click)="saveApp()">
    Save changes
  </button>
  <!-- <button type="button" class="btn btn-default" *ngIf="showAddApp == false" (click)="bsModalRef.hide()">Close</button> -->
</div>

<ng-template #template class="modal-confirmation">
  <div class="modal-body text-center">
    <p>
      Warning: This will remove this App from your Practice Library and from all
      client home pages that use this App. Click Remove to confirm removing this
      App.
    </p>
    <button type="button" class="btn btn-danger pull-left" (click)="confirm()">
      Remove
    </button>
    <button
      type="button"
      class="btn btn-default pull-right"
      (click)="decline()"
    >
      Cancel
    </button>
  </div>
</ng-template>
